import { computed } from 'vue'
import { EVENT_TYPE } from '@/common/resources/const'
import { isApiUrl } from '@/common/utils/is-api-url'
import { isCatalogViewMore } from '@/common/utils/view-more/is-catalog-view-more'
import { navigateViewMoreCatalog } from '@/common/utils/view-more/navigate-view-more-catalog'
import { navigateViewMoreOldFashioned } from '@/common/utils/view-more/navigate-view-more-old-fashioned'
import { navigateViewMoreQuickPush } from '@/common/utils/view-more/navigate-view-more-quick-push'
import { useRouter } from 'vue-router/composables'

export const useViewMore = (sectionInfo) => {
  const router = useRouter()
  const viewMoreObject = sectionInfo?.eventlist?.find(
    (event) => event.type === EVENT_TYPE.ON_VIEW_MORE,
  )

  const hasViewMore = computed(() => {
    return viewMoreObject !== undefined
  })

  /**
   * view more title 을 반환
   * @param defaultTitle
   * @returns {*}
   */
  const viewMoreTitle = (defaultTitle) => {
    return viewMoreObject?.title ?? defaultTitle
  }

  /**
   * view more 클릭 시 이벤트
   * 1. navigateViewMoreCatalog: 카탈로그 타입의 view more 딥링크 클릭 시 (www.wavve.com/viewmore?code=...)
   * 2. navigateViewMoreOldFashioned: 구형 타입의 view more 클릭 시 (apis.wavve.com/...)
   * 3. navigateViewMoreQuickPush: apis.wavve.com 과 같은 api 형식이 아닌 my_view 와 같은 페이지 형식일 경우
   * quick push 타입의 view more 클릭 시
   * @returns {Promise<Route>}
   */
  const onClickViewMore = () => {
    const url = viewMoreObject?.url

    if (isCatalogViewMore(url)) {
      return router.push(navigateViewMoreCatalog(url)).catch(() => {})
    }

    if (isApiUrl(url)) {
      return router.push(navigateViewMoreOldFashioned(url)).catch(() => {})
    }

    return router.push(navigateViewMoreQuickPush(url)).catch(() => {})
  }

  return {
    hasViewMore,
    onClickViewMore,
    viewMoreTitle,
  }
}
